// Configuración del cuestionario de registro (12 campos definidos, ramificado por modalidad Q04).
export const AVISO_INICIAL =
  "Tómate 1 minuto para realizar este proceso. Al finalizar, te mostraremos únicamente las alternativas que mejor se adaptan a tu perfil. No afecta tu historial crediticio ni representa una aprobación definitiva.";

export const AVISO_INTERMEDIACION =
  "Autofinanza es una plataforma tecnológica de intermediación. No otorga créditos ni garantiza su aprobación. Las condiciones, aprobación y contratación son determinadas exclusivamente por cada institución participante.";

export const MODALIDADES = ["Crédito", "Arrendamiento", "Pago de contado", "Aún no estoy seguro"];

export const TIPOS_VEHICULO = [
  "Automóvil", "SUV", "Pickup", "Van o camioneta comercial",
  "Camión", "Tractocamión", "Maquinaria pesada", "Aún no estoy seguro",
];

export const INGRESOS = [
  "Menos de $15,000", "De $15,000 a $25,000", "De $25,001 a $40,000",
  "De $40,001 a $60,000", "Más de $60,000",
];

export const FUENTES_INGRESO = [
  "Empleado", "Negocio propio", "Profesional independiente",
  "Empresario o representante de empresa", "Pensionado", "Otro",
];

export const ANTIGUEDAD = [
  "Menos de 6 meses", "De 6 a 12 meses", "De 1 a 2 años", "Más de 2 años",
];

export const ENGANCHES = [
  "Por ahora no cuento con enganche", "Menos del 10%", "Del 10% al 20%",
  "Más del 20%", "Aún no lo sé",
];

export const HISTORIAL = [
  "Excelente: siempre pago puntualmente",
  "Bueno: generalmente pago a tiempo",
  "Regular: he tenido algunos atrasos",
  "Complicado: tengo atrasos importantes o cuentas vencidas",
  "No tengo historial crediticio",
  "No estoy seguro",
];

export const EDADES = [
  "18 a 24 años", "25 a 34 años", "35 a 44 años",
  "45 a 54 años", "55 a 64 años", "65 años o más",
];

// Rutas
export const isContado = (q04) => q04 === "Pago de contado";
